import { PROFILE_GA_CATEGORY, PREVIEW_PROFILE_GA_CATEGORY } from '../../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../../EventTrackingConstants';
import { AnalyticsTypes } from '../../../../middleware/google-analytics';
import { INVITE_DOCTOR_FORM_KEY } from './constants';
import { inviteDoctorFormSelector } from './selector';
import { get } from 'lodash';

export const ActionTypes = {
    CLAIM_THIS_PROFILE: `${INVITE_DOCTOR_FORM_KEY}/claim_this_profile`,
    FIND_AVAILABLE_NEAR_YOU: `${INVITE_DOCTOR_FORM_KEY}/find_available_near_you`,
    INPUT_DOCTORS_EMAIL: `${INVITE_DOCTOR_FORM_KEY}/input_doctors_email`,
    INPUT_FIRST_NAME: `${INVITE_DOCTOR_FORM_KEY}/input_first_name`,
    INPUT_LAST_NAME: `${INVITE_DOCTOR_FORM_KEY}/input_last_name`,
    CLICK_SEND: `${INVITE_DOCTOR_FORM_KEY}/click_send`,
    CLICK_FIND_SIMILAR_DOCTORS: `${INVITE_DOCTOR_FORM_KEY}/click_find_similar_doctors`,
    CLICK_FIND_ANOTHER_DOCTOR: `${INVITE_DOCTOR_FORM_KEY}/click_find_another_doctor`,
    EMAIL_INVALID: `${INVITE_DOCTOR_FORM_KEY}/email_invalid`,
    FIRST_NAME_INVALID: `${INVITE_DOCTOR_FORM_KEY}/first_name_invalid`,
    LAST_NAME_INVALID: `${INVITE_DOCTOR_FORM_KEY}/last_name_invalid`,
    SUBMIT_FORM_SUCCESS: `${INVITE_DOCTOR_FORM_KEY}/submit_form_success`,
    SUBMIT_FORM_FAILURE: `${INVITE_DOCTOR_FORM_KEY}/submit_form_failure`,
};

export const inputDoctorsEmail = email => ({
    type: ActionTypes.INPUT_DOCTORS_EMAIL,
    payload: { email },
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Input Doctors Email',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.TYPE,
                Element: TARGETS.DOCTORS_EMAIL_TEXTBOX,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'InputDoctorsEmail',
            },
        },
    },
});

export const inputFirstName = firstName => ({
    type: ActionTypes.INPUT_FIRST_NAME,
    payload: { firstName },
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Input First Name',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.TYPE,
                Element: TARGETS.FIRST_NAME_TEXTBOX,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'InputFirstName',
            },
        },
    },
});

export const inputLastName = lastName => ({
    type: ActionTypes.INPUT_LAST_NAME,
    payload: { lastName },
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Input Last Name',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.TYPE,
                Element: TARGETS.LAST_NAME_TEXTBOX,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'InputLastName',
            },
        },
    },
});

export const clickSend = () => ({
    type: ActionTypes.CLICK_SEND,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Send',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.INVITE_DOCTOR_FORM_SEND_BUTTON,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickSend',
            },
        },
    },
});

export const clickFindAnotherDoctor = () => ({
    type: ActionTypes.CLICK_FIND_ANOTHER_DOCTOR,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Find Another Doctor',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.INVITE_DOCTOR_FORM_FIND_ANOTHER_DOCTOR_BUTTON,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickFindAnotherDoctor',
            },
        },
    },
});

export const trackClickFindSimilarDoctors = () => {
    const referrerUrl = window.location.href;

    return {
        type: ActionTypes.CLICK_FIND_SIMILAR_DOCTORS,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click Find Similar Doctors',
                category: PREVIEW_PROFILE_GA_CATEGORY,
                tags: [],
                data: {
                    Section: TARGETS.BOOK_AN_APPOINTMENT,
                    Component: TARGETS.INVITE_DOCTOR_FORM,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Element: TARGETS.FIND_SIMILAR_DOCTORS_BUTTON,
                    Initiator: EVENT_INITIATORS.USER,
                    EventAction: 'ClickFindSimilarDoctors',
                    EventDetails: { referrerUrl },
                },
            },
        },
    };
};

export const emailInvalid = () => ({
    type: ActionTypes.EMAIL_INVALID,
});

export const firstNameInvalid = () => ({
    type: ActionTypes.FIRST_NAME_INVALID,
});

export const lastNameInvalid = () => ({
    type: ActionTypes.LAST_NAME_INVALID,
});

export const submitFormSuccess = () => ({
    type: ActionTypes.SUBMIT_FORM_SUCCESS,
});

export const submitFormFailure = () => ({
    type: ActionTypes.SUBMIT_FORM_FAILURE,
});

export const claimThisProfile = () => ({
    type: ActionTypes.CLAIM_THIS_PROFILE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Clicked Claim This Profile',
            category: PROFILE_GA_CATEGORY,
            tags: [],
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.INVITE_DOCTOR_FORM,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.INVITE_DOCTOR_FORM_CLAIM_THIS_PROFILE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickedClaimThisProfile',
            },
        },
    },
});

const apiHost = process.env.API_HOST || '';
export const inviteDoctorFormUrl = '/profile/inviteinactiveprofessional';
const inviteDoctorFormEndpoint = `${apiHost}${inviteDoctorFormUrl}`;

const checkInviteDoctorFormIsValid = (inviteDoctorFormState, dispatch) => {
    let isValid = true;

    if (!inviteDoctorFormState.emailValid) {
        isValid = false;
    }

    if (!inviteDoctorFormState.doctorsEmail) {
        isValid = false;
        dispatch(emailInvalid());
    }

    if (!inviteDoctorFormState.firstName) {
        isValid = false;
        dispatch(firstNameInvalid());
    }

    if (!inviteDoctorFormState.lastName) {
        isValid = false;
        dispatch(lastNameInvalid());
    }

    return isValid;
};

export function submitFormFetch(inviteDoctorFormState, provider) {
    return fetch(inviteDoctorFormEndpoint, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
            PersonIdentifierSource: provider.personIdentifierSource,
            PersonIdentifierValue: provider.monolithId,
            ReferredEmail: inviteDoctorFormState.doctorsEmail,
            ReferrerFirstName: inviteDoctorFormState.firstName,
            ReferrerLastName: inviteDoctorFormState.lastName,
        }),
    })
        .then(response => {
            if (response.status !== 200) {
                return new Promise(resolve => {
                    resolve({ status: response.status });
                });
            }
            return response.json()
                .then(body => ({
                    status: response.status,
                    body,
                }));
        });
}

export function submitForm() {
    return (dispatch, getState) => {
        const state = getState();
        const inviteDoctorFormState = inviteDoctorFormSelector(state);
        const provider = get(state, 'profile.provider', {});

        dispatch(clickSend());

        if (!checkInviteDoctorFormIsValid(inviteDoctorFormState, dispatch)) {
            return;
        }

        return submitFormFetch(inviteDoctorFormState, provider)
            .then(({ status }) => {
                if (status === 200) {
                    dispatch(submitFormSuccess());
                } else {
                    dispatch(submitFormFailure());
                }
            })
            .catch(() => {
                dispatch(submitFormFailure());
            });
    };
}
